import { useMemo } from "react";
import { useSelector } from "react-redux";
import { IState } from "../data/reducers/state";

/**
 * Hook to get tenure options for a specific association
 * Returns select options formatted for Mantine Select/MultiSelect components
 */
export function useTenures(associationId?: string) {
    const association = useSelector((state: IState) =>
        associationId ? state.associations.map[associationId] : null
    );

    const tenures = useMemo(() => {
        return association?.config?.tenures || [];
    }, [association?.config?.tenures]);

    const tenureOptions = useMemo(() => {
        return tenures.map(tenure => ({
            value: tenure.id,
            label: tenure.displayLabel,
        }));
    }, [tenures]);

    const defaultTenure = useMemo(() => {
        return tenures.find(t => t.isDefault)?.id || tenures[0]?.id;
    }, [tenures]);

    const getTenureLabel = (tenureId?: string | null) => {
        if (!tenureId) return '-';
        const tenure = tenures.find(t => t.id === tenureId);
        return tenure?.displayLabel || tenureId;
    };

    return {
        tenures,
        tenureOptions,
        defaultTenure,
        getTenureLabel,
    };
}
